import { createTheme } from '@mui/material/styles';

// Fuentes del sistema: evitan conexiones a proveedores externos al abrir la web.
const DISPLAY = "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif";
const BODY = "'Segoe UI', 'Helvetica Neue', Arial, sans-serif";

// --- Tokens de color del nuevo sistema (dark + light, rojo de acento) ---
const INK = '#0E0E10';       // negro de secciones oscuras y footer
const INK_SOFT = '#17171A';  // oscuro un punto más claro (tarjetas sobre oscuro)
const PAPER = '#F6F6F4';     // claro cálido de secciones claras
const PAPER_PURE = '#FFFFFF';
const RED = '#E63644';       // acento
const RED_DARK = '#C42A36';

const TEXT_ON_LIGHT = '#16161A';
const TEXT_ON_LIGHT_SOFT = '#5A5A62';
const TEXT_ON_DARK = '#FFFFFF';
const TEXT_ON_DARK_SOFT = '#B7B7BE';

const theme = createTheme({
  palette: {
    primary: {
      main: INK, // negro de marca (navbar sólido, fondos oscuros)
    },
    secondary: {
      main: RED, // acento rojo
      dark: RED_DARK,
    },
    tertiary: {
      main: '#ffffff',
    },
    cuarto: {
      main: '#f51827',
    },
    background: {
      default: PAPER,
      primary: '#333333',   // (legacy) — usado aún por páginas no migradas
      secondary: '#222222', // (legacy)
    },
    card: {
      background: '#ec3642', // (legacy) Card antiguo
      textColor: 'white',
    },
    // --- Nuevos tokens del sistema de diseño ---
    ink: { main: INK, soft: INK_SOFT, contrastText: TEXT_ON_DARK },
    paper2: { main: PAPER, pure: PAPER_PURE, contrastText: TEXT_ON_LIGHT },
    accent: { main: RED, dark: RED_DARK, contrastText: '#ffffff' },
    ink_text: { primary: TEXT_ON_DARK, secondary: TEXT_ON_DARK_SOFT },
    light_text: { primary: TEXT_ON_LIGHT, secondary: TEXT_ON_LIGHT_SOFT },
    divider: 'rgba(0,0,0,0.10)',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: BODY,
    h1: {
      fontFamily: DISPLAY,
      fontSize: 'clamp(2.05rem, 8vw, 4.2rem)',
      fontWeight: 700,
      lineHeight: 1.05,
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      overflowWrap: 'break-word',
    },
    h2: {
      fontFamily: DISPLAY,
      fontSize: 'clamp(2rem, 4vw, 2.9rem)',
      fontWeight: 700,
      lineHeight: 1.08,
      letterSpacing: '-0.005em',
      textTransform: 'uppercase',
      marginBottom: '0.5rem',
    },
    h3: {
      fontFamily: DISPLAY,
      fontSize: 'clamp(1.5rem, 2.6vw, 2rem)',
      fontWeight: 600,
      lineHeight: 1.15,
      textTransform: 'uppercase',
      marginBottom: '0.5rem',
    },
    h4: {
      fontFamily: DISPLAY,
      fontSize: '1.35rem',
      fontWeight: 600,
      lineHeight: 1.2,
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: DISPLAY,
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: '1.15rem',
      lineHeight: 1.55,
      fontWeight: 400,
    },
    body1: {
      fontSize: '1.02rem',
      lineHeight: 1.65,
    },
    body2: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
    },
    overline: {
      fontFamily: DISPLAY,
      fontSize: '0.85rem',
      fontWeight: 600,
      letterSpacing: '0.18em',
      textTransform: 'uppercase',
    },
    button: {
      fontFamily: DISPLAY,
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '0.7rem 1.8rem',
        },
        containedSecondary: {
          backgroundColor: RED,
          color: '#fff',
          '&:hover': { backgroundColor: RED_DARK },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': { borderWidth: '2px' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          overflow: 'hidden',
          boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
        },
      },
    },
  },
});

export default theme;
